import React, { useEffect, useContext, useRef, useState } from 'react'
import { NextpageContext } from '../context/nextpage.context'

export type IDropdownProps = {
  dropdownList: string[],
  clickHandler?: (event: any) => void,
  selectDropdown?: boolean
}

const NpDropdown = ({
  dropdownList,
  clickHandler,
  selectDropdown
}: IDropdownProps) => {
  const nextpage = useContext(NextpageContext)
  const dropdownRef = useRef(null)

  const [active, setActive] = useState(false)
  const [buttonText, setButtonText] = useState(dropdownList[0])
  const [activeOption, setActiveOption] = useState(0)
  const ariaPressed = 'aria-pressed'

  let dropdownClass = `aria-haspopup ${active ? ariaPressed : ''}`

  if (!selectDropdown) {
    useEffect(() => {
      nextpage.UI.components.dropdown(dropdownRef.current)
    })
  }

  const dropdowns = dropdownList.map((dl, i) => (
    <li key={i} role='option' aria-selected={i === activeOption ? true : false} className={`panel-heading ${i === activeOption ? 'aria-selected' : ''}`} 
    onClick={(event) => {
      if (clickHandler) {clickHandler(event)}
      setButtonText(dl)
      setActiveOption(i)
    }}>
      {dl}
    </li>
  ))
  
  return (
    <React.Fragment>
      <div ref={dropdownRef} className='dropdown'>
        <button type='button' className={dropdownClass} aria-haspopup='true' aria-pressed={active ? 'true' : 'false'} onClick={() => setActive(!active)}>
          {buttonText}
        </button>
        <ul role='listbox' className={active ? 'aria-expanded' : ''} aria-expanded={active ? true : false} onClick={() => setActive(!active)}>
          {dropdowns}
        </ul>
      </div>
    </React.Fragment>
  )
}

export default NpDropdown
